import { z } from "zod";
import { mediaListSchema } from "../common.js";

export const vtRemarksSchema = z
  .object({
    globalRemarks: z.string().optional(),
    diversMedia: mediaListSchema.optional(),
  })
  .partial();

export type VtRemarks = z.infer<typeof vtRemarksSchema>;
